module.exports = __webpack_public_path__ + "img/Identity-Pattern2.d0f21cf3.svg";